export default "__VITE_PUBLIC_ASSET__63c49f11__"